import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/header.component';
import { Footer } from '../components/footer.component';
import SectionHeader from '../components/common';
import { useTranslation } from 'react-i18next';
import '../scss/self-employed-invoicing.style.scss';
import FreelancerCtaSection from '../components/freelancer-call-to-action';
import { InvozioAsFreelancer } from '../components/images/png/icons';
import SelfEmployedInvoicingPageComponent from '../components/self-employed-invoicing.component';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import SEOMetadataComponent from '../components/seo-metadata.component';

export const SelfEmployedInvoicingPage: React.FC = () => {
      const { t, i18n } = useTranslation();
    
        const currentLanguage = i18n.language;
    
        const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
        const canonicalUrl = isEnglish
            ? `https://www.invozio.com/invoicing-as-an-individual_self-employed?lang=${LOCALES.EN_US}`
            : `https://www.invozio.com/fakturera-som-privatperson_egenanstalld?lang=${LOCALES.SV_SE}`;
    
       
        const schemaMarkup = getSchemaMarkup("fakturera-som-privatperson_egenanstalld");

        // FAQ Schema Markup for SEO
        const faqSchemaMarkup = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": t("FAQ_PRIVATE_INVOICING_Q1"),
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": t("FAQ_PRIVATE_INVOICING_A1")
                    }
                },
                {
                    "@type": "Question",
                    "name": t("FAQ_PRIVATE_INVOICING_Q2"),
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": t("FAQ_PRIVATE_INVOICING_A2")
                    }
                },
                {
                    "@type": "Question",
                    "name": t("FAQ_PRIVATE_INVOICING_Q3"),
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": t("FAQ_PRIVATE_INVOICING_A3")
                    }
                },
                {
                    "@type": "Question",
                    "name": t("FAQ_PRIVATE_INVOICING_Q4"),
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": t("FAQ_PRIVATE_INVOICING_A4")
                    }
                },
                {
                    "@type": "Question",
                    "name": t("FAQ_PRIVATE_INVOICING_Q5"),
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": t("FAQ_PRIVATE_INVOICING_A5")
                    }
                },
                {
                    "@type": "Question",
                    "name": t("FAQ_PRIVATE_INVOICING_Q6"),
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": t("FAQ_PRIVATE_INVOICING_A6")
                    }
                }
            ]
        };
    return (
        <>
            <Header />
             <SEOMetadataComponent
                title={t('SELF_EMPLOYED_INVOICING_PAGE_TITLE')}
                description={t('SELF_EMPLOYED_META_DESCRIPTION')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            />
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(faqSchemaMarkup)}
                </script>
            </Helmet>
            <SectionHeader
                titleKey={t('SELF_EMPLOYED_INVOICING_PAGE_TITLE')}
                className="invozio-news-section"
                titleClassName="main-title"
                subtitleClassName="sub-title"
                alignment="center"
            />
            <SelfEmployedInvoicingPageComponent/>
            <FreelancerCtaSection
                title={t('LET_INVOZIO_HELP_YOU_AS_FREELANCER')}
                description={[t('FREELANCING_REWARDING_CAREER_TEXT_1'), t('FREELANCING_REWARDING_CAREER_TEXT_2')]}
                buttonText={t('CREATE_FREE_ACCOUNT')}
                imageSrc={InvozioAsFreelancer}
                imageAlt="Freelancer illustration"
            />
            <div className="bg-footer">
                <Footer />
            </div>
        </>
    );
};

export default SelfEmployedInvoicingPage;
